/**
 * Reordena un elemento dentro de un string separado por comas
 * @param {string} valor - String con valores separados por coma
 * @param {number} posicion - Posición actual del elemento
 * @param {number} direccion - -1 para subir, 1 para bajar
 * @returns {string} - String reordenado
 */
export const moverElementoEnString = (valor, posicion, direccion) => {
  const elementos = valor.split(",").map(s => s.trim());
  const nuevaPos = posicion + direccion;
  if (nuevaPos < 0 || nuevaPos >= elementos.length) return valor;
  [elementos[posicion], elementos[nuevaPos]] = [elementos[nuevaPos], elementos[posicion]];
  return elementos.join(",");
};
